import { useTranslation } from 'react-i18next'

const SLOT_LABELS: Record<string, string> = {
  hero: 'amazonListing.slots.hero',
  lifestyle_event: 'amazonListing.slots.lifestyleEvent',
  lifestyle_diy: 'amazonListing.slots.lifestyleDiy',
  infographic: 'amazonListing.slots.infographic',
  packaging: 'amazonListing.slots.packaging',
  comparison: 'amazonListing.slots.comparison',
  trust_brand: 'amazonListing.slots.trustBrand',
}

interface SlotHeaderProps {
  slotNumber: number
  slotPurpose: string
}

export function SlotHeader({ slotNumber, slotPurpose }: SlotHeaderProps) {
  const { t } = useTranslation()
  const labelKey = SLOT_LABELS[slotPurpose] ?? slotPurpose

  return (
    <div className="bg-neutral-50 dark:bg-neutral-800/50 px-6 py-4 flex items-center gap-3 border-b border-neutral-200 dark:border-neutral-700">
      <span className="bg-orange-500 text-white font-extrabold text-sm w-9 h-9 flex items-center justify-center rounded-lg">
        {String(slotNumber).padStart(2, '0')}
      </span>
      <div>
        <div className="font-semibold text-neutral-900 dark:text-neutral-100">{t(labelKey)}</div>
        <div className="text-xs text-neutral-500">
          {t('amazonListing.concept.galleryPosition', { position: slotNumber })}
        </div>
      </div>
      <span className="ml-auto bg-neutral-200 dark:bg-neutral-700 px-2.5 py-0.5 rounded-full text-2xs text-neutral-500">
        PT{String(slotNumber).padStart(2, '0')}
      </span>
    </div>
  )
}
